import styled from "styled-components";
import { responsive } from "theme/reponsive";

export const SingleSchoolBannerContainer = styled.div<{ url: string }>`
   background-image: linear-gradient(#000000c7, #0c0c0c80), url(${({ url }) => url});
   min-height: 200px;
   height: 337px;
   background-position: center;
   background-size: cover;
   background-repeat: no-repeat;
   width: 100%;
   padding: 0 5rem;

   ${responsive("$small")`
   padding: 0 2rem;
   height: 100vh
`}
`;

export const SingleSchoolBannerWrapper = styled.div`
   display: flex;
   flex-direction: column;
   justify-content: center;
   height: 80%;

   ${responsive("$small")`
   padding: 5rem 0;
   justify-content: center,
`}

   .btn-container {
      display: flex;
      margin-top: 20px;
      gap: 1rem;

      ${responsive("$xsmall")`
      flex-direction: column;
      justify-content: flex-start;
      gap: 1rem;
   `}

      ${responsive("$large")`
   z-index: 40;
`}
   
   button {
         margin-left: 0;

         &:first-child {
            margin-right: 15px;
         }

         & > * + * {
            margin-left: 0;
         }
      }
   }
`;

export const SchoolAdvertsWrapper = styled.div`
   width: 100%;
   margin-bottom: 15px;
   max-height: 200px;

   ${responsive("$xsmall")`
   padding: 1rem;
   `}

   img {
      width: 100%;
      margin: auto;
      height: 100%;
      object-fit: cover;
   }
`;

export const SingleSchoolBody = styled.div`
   display: grid;
   grid-template-columns: 2.3fr 1fr;
   column-gap: 30px;
   color: #000;
   margin: 50px 0;
   height: 100%;
   position: relative;
   width: 100%;

   ${responsive("$medium")`
     display: flex;
     flex-direction: column; 
  `}

   .right-content {
      background-color: transparent;
      align-self: flex-start;
      height: 100%;

      ${responsive("$medium")`
            position: fixed;
            bottom: 0;
            width: 100%;
      `}
   }

   .left-content {
      display: flex;
      flex-direction: column;

      ${responsive("$medium")`
      z-index: 500
   `}

      .slider-images-container {
         border: 1px solid;
         height: 420px;
         width: 100%;
         position: relative;
         background-color: #000;

         .carousel-item {
            width: 100%;

            height: 420px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: 50%;
         }
      }

      .school-details {
         box-shadow: 0 3px 25px rgb(0 0 0 / 6%);
         background-color: #fff;
         border-radius: 4px;
         padding: 30px 20px;
         margin: 5px 0;

         &.main {
            min-height: 300px;
         }

         .brief {
            h6 {
               font-size: 16px;
               text-transform: uppercase;
               color: #555;
            }

            li,
            p {
               font-size: 1.5rem;
               margin: 10px 0;
               line-height: 3rem;
               color: #666;
               list-style: circle;
            }
         }

         .school-tab-items {
            margin-bottom: 40px;

            ${responsive("$medium")`
            display: grid;
            grid-template-columns: repeat(4, 1fr);
         `}

            button {
               background-color: transparent;
               outline: none;
               border: none;
               margin-right: 50px;
               font-weight: 400;
               color: #bbb;
               padding-bottom: 5px;
               cursor: pointer;

               &:last-of-type {
                  margin-right: 0;
               }

               ${responsive("$medium")`
               margin-right: 10px;
               text-overflow: ellipsis;
               overflow: hidden; 
               white-space: nowrap;
               cursor: pointer;
               height: 50px;
               z-index: 500;
               
            `}

               ${responsive("$xsmall")`
               font-size: 1rem;
         `}

               &.active {
                  cursor: pointer;
                  color: #4c4c4c;
                  font-weight: 500;
                  border-bottom: 3px solid ${({ theme }) => theme.colors?.primary};
               }
            }
         }
      }
   }
`;

export const VideosWrapper = styled.div`
   display: grid;
   grid-template-columns: repeat(2, 1fr);
   grid-gap: 40px 20px;

   ${responsive("$small")`
      grid-template-columns: repeat(1, 1fr);
  `}
`;

export const NewSchoolBannerContainer = styled.div`
   background: #06152d;
   min-height: 420px;
   width: 100%;
   padding: 77px 215px 43px 120px;
   /* margin-top: 5rem; */
   display: flex;
   justify-content: space-between;
   .hide {
      display: none;
   }

   .school-header-content {
      width: 734px;
      .school-header-meta {
         display: flex;
         align-items: center;

         .school-header-name {
            color: #ffffff;
            font-style: normal;
            font-weight: 600;
            font-size: 50px;
            line-height: 56px;
            width: 85%;
            text-transform: capitalize;
         }

         .school-header-verified {
            width: 108px;
            height: 38px;
            margin-left: 19px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 8px;
            display: flex;
            justify-content: center;
            align-items: center;
         }

         .school-header-verified-text {
            color: #fff;
            margin-left: 7px;
            font-weight: 400;
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 0.02em;
         }
      }

      .school-about {
         margin-top: 24px;
         font-size: 20px;
         line-height: 32px;
         color: #ffffff;
         display: -webkit-box;
         -webkit-line-clamp: 3;
         -webkit-box-orient: vertical;
         overflow: hidden;
         text-overflow: ellipsis;
         height: fit-content;
         white-space: normal;
         width: 626px;
         height: 96px;
      }

      .ratings {
         margin-top: 24px;
         display: flex;
         align-items: center;

         p {
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 0.002em;
            color: #fff;
            margin-right: 10.5px;
         }
      }

      .buttons {
         margin-top: 24px;
         display: flex;
         align-items: center;

         div {
            &:not(:last-child) {
               margin-right: 12px;
            }
            &:last-child {
               margin-left: 22px;
            }
         }
      }
   }

   .logo-div {
      width: 199px;

      .school-logo {
         width: 199px;
         height: 199px;

         img {
            width: 100%;
            height: 100%;
            object-fit: cover;
         }
      }

      .like-meta {
         width: 146px;
         display: flex;
         align-items: center;
         justify-content: space-between;
         height: 32px;
         padding: 0 8px 0 9px;
         background: #3678e5;
         border-radius: 4px;
         margin: 32px auto 10px;

         div.like-meta-div {
            display: flex;
            align-items: center;
            p {
               font-weight: 500;
               font-size: 16px;
               line-height: 16px;
               letter-spacing: 0.02em;
               color: #ffffff;
               margin-left: 5.5px;
            }
         }

         div.hr {
            background: #a5adc0;
            height: 12px;
            width: 1px;
         }
      }
   }

   ${responsive("$small")`
   padding: 0 2rem;
    min-height: 464px;
    height: auto;
    padding: 21px 20px 29px;
    flex-direction: column;
    justify-content: flex-start;

      .ratings {
         margin-top: 20px;
         display: flex;
         align-items: center;

         p {
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            letter-spacing: 0.002em;
            color: #fff;
            margin-right: 10.5px;
         }
      }

      .buttons {
         margin-top: 20px;
         display: flex;
         align-items: center;

         div {
            &:not(:last-child) {
               margin-right: 12px;
            }
         }
      }

     .school-header-content {
      width: 100%;
         .show {
            display: none;
         }
         .school-header-meta {
            align-items: flex-start;
            flex-direction: column-reverse;
               .school-header-name {
                  font-size: 24px;
                  line-height: 30px;
                  width: 100%;
               }
               .school-header-verified {
                  align-self: flex-end
               }
         }
         .school-about {
            margin-top: 12px;
            font-size: 14px;
            height: 88px;
            width: 100%;
            margin-bottom: 20px;
         }
      }
      .logo-div  {
         width: 100%;
         display: flex;
         align-items: center;

         .school-logo {
            width: 99px;
            height: 99px;
            margin-right: 32px;
         }
         .like-meta {
            margin-top: 0
         }
      }
   `}

   ${responsive("$tiny")`
      .buttons {
         flex-direction: column;
         align-items: flex-start;
         .last-child {
            margin-top: 10px;
         }
       
      }
   `}
`;

export const NewSchoolContainer = styled.div`
   margin: 0 auto;
   position: relative;
   max-width: 120rem;
   padding: 4rem 0 4.8rem;
   ${responsive("$small")`
      max-width: 100%;
      padding: 2.4rem 2rem 4rem;
   `}
`;

export const DetailsFlexDiv = styled.div`
   display: flex;
   justify-content: space-between;

   .first-details-div {
      width: 78.6rem;

      .slider-images-container {
         border: 1px solid;
         height: 363px;
         width: 100%;
         position: relative;
         background-color: #000;
         border-radius: 4px 4px 0px 0px;

         .carousel-item {
            width: 100%;
            height: 363px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
         }
      }

      .school-details {
         background-color: #fff;
         margin: 44px 0 24px;
         min-height: 300px;

         .brief {
            border: 1px solid #d7dce0;
            border-radius: 0px 0px 4px 4px;
            padding: 24px;

            h6 {
               font-size: 20px;
               text-transform: capitalize;
               color: #151f34;
               font-weight: 600;
               line-height: 32px;
            }

            li,
            p {
               font-size: 1.8rem;
               margin: 8px 0;
               line-height: 3.2rem;
               color: #3d414b;
               list-style: circle;
            }

            ${responsive("$small")`
            border: none;
             border-top: 1px solid #d7dce0;
 
            padding: 20px 0;
            h6 {
               font-size: 18px;
               line-height: 24px;
            }

            li, p {
                 font-size: 14px;
               line-height: 24px;
            }
         `}
         }

         .school-tab-items {
            ${responsive("$medium")`
            display: grid;
            grid-template-columns: repeat(4, 1fr);
         `}
            ${responsive("$small")`
            display: grid;
            grid-template-columns: repeat(3, 1fr);
         `}

            button {
               background-color: transparent;
               outline: none;
               border: none;
               margin-right: 20px;
               font-weight: 600;
               color: #6d7a98;
               padding: 0 16px 10px;
               cursor: pointer;

               &:last-of-type {
                  margin-right: 0;
               }

               ${responsive("$medium")`
               margin-right: 10px;
               white-space: nowrap;
               cursor: pointer;
               height: 50px;
               z-index: 300;
               
            `}

               ${responsive("$xsmall")`
                  font-weight: 500;
                  font-size: 14px;
                  line-height: 16px;
               `}

               &.active {
                  cursor: pointer;
                  color: #3d414b;
                  font-weight: 600;
                  border-bottom: 3px solid ${({ theme }) => theme.colors?.primary};

                  ${responsive("$xsmall")`
                  font-weight: 500;
                  `}
               }
            }
         }
      }
   }

   .second-details-div {
      width: 39rem;

      .school-meta {
         min-height: 560px;
         background: #f7f9fb;
         width: 100%;
         border-radius: 8px;
         padding: 24px;

         &_name {
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            letter-spacing: 0.02em;
            color: #151f34;
            margin-bottom: 12px;
            text-transform: capitalize;
         }

         &_div {
            &:not(:first-of-type) {
               margin-top: 16px;
            }

            &-label {
               font-size: 14px;
               line-height: 16px;
               letter-spacing: 0.01em;
               color: #a5adc0;
            }

            &-text {
               font-size: 16px;
               line-height: 16px;
               letter-spacing: 0.25px;
               color: #151f34;
               margin-top: 8px;
               text-transform: capitalize;
            }

            .green-text {
               font-weight: 600;
               color: #2cb57a;
            }
         }

         .btns-div {
            margin-top: 2.4rem;
         }

         .call {
            margin-top: 1rem;
            p {
               font-size: 18px;
               line-height: 16px;
               text-align: center;
               letter-spacing: 0.25px;
               color: #6d7a98;
            }
            span {
               display: inline-block;
               font-weight: 500;
               font-size: 18px;
               letter-spacing: 0.02em;
               color: #151f34;
            }
         }

         &_title {
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.02em;
            color: #151f34;
            margin-bottom: 16px;
            text-transform: capitalize;
         }
      }
   }

   ${responsive("$medium")`
      flex-direction: column;
         .first-details-div { 
            width: 100%
         }
         .second-details-div { 
            width: 100%;
            .school-meta {
               padding: 16px;
                 &_name {
                     font-size: 16px;
                     line-height: 24px;
                  }
                  &_div {
                     &-label {
                        font-size: 12px;
                     }

                     &-text {
                        font-size: 14px;
                     }
                  }

                  .call {
                     p, span {
                        font-size: 16px;
            
                     }
           
                  }
            }
         }
   `}
`;

export const AdvertDiv = styled.div`
   margin-top: 24px;
   display: flex;
   justify-content: space-between;

   .ad-card {
      width: 592px;
      height: 241px;

      img {
         width: 100%;
         height: 100%;
         object-fit: cover;
         border-radius: 8px;
      }
   }

   ${responsive("$medium")`
      flex-direction: column;

      .ad-card {
         width: 100%;
         height: 241px;

         &:last-of-type {
            margin-top: 1.6rem
         }
      }
   `}
`;

export const ReviewDiv = styled.div`
   margin-top: 40px;
   display: flex;
   justify-content: space-between;
   padding: 24px;
   border: 1px solid rgba(215, 220, 224, 0.4);
   border-radius: 8px;

   .read-review {
      width: 584px;
   }

   .write-review {
      width: 544px;
   }

   ${responsive("$medium")`
      flex-direction: column;
       border: none;

      .read-review, .write-review {
         width: 100%;
      }
   `}
`;
